import React from 'react'
import { Button, Grid, Modal, TextArea, XFilledIcon } from 'react-unity';
import CloudAccount from '../../../models/CloudAccount';
import moment from 'moment';

interface CloudAccountReasonModalProps{
    reasonModalVisible: boolean;
    selectedCloudAccount: CloudAccount;
    setReasonModalVisible: any;
}

const CloudAccountReasonModal = ({
    reasonModalVisible,
    selectedCloudAccount,
    setReasonModalVisible,
}: CloudAccountReasonModalProps) => {

    return (
        <Modal show={reasonModalVisible}>
            <Modal.Window>
                <Modal.Window.Header>
                    <Modal.Window.Header.Title>
                        {selectedCloudAccount?.createdUserPrincipalName}
                    </Modal.Window.Header.Title>
                    <Modal.Window.Header.CloseButton
                        onClick={() => setReasonModalVisible(false)}
                    >
                        <XFilledIcon />
                    </Modal.Window.Header.CloseButton>
                </Modal.Window.Header>
                <Modal.Window.Body id="reason-modal-body">
                {selectedCloudAccount?.workflowInstance.workflowInstanceStates.map((state) => (
                        <TextArea
                            label={`${state.workflowState.name} on ${moment(state.performedOnDate).format('MM/DD/YYYY')} by ${state.performedByUser.displayName}`}
                            disabled
                            value={`Reason: ${state.performedReason}`}
                        />
                ))}
                </Modal.Window.Body>
                <Modal.Window.Footer>
                    <Grid variant="2-up">
                        <Grid.Item>
                            <Button
                                variant="secondary"
                                onClick={() => setReasonModalVisible(false)}
                            >
                                Close
                            </Button>
                        </Grid.Item>
                    </Grid>
                </Modal.Window.Footer>
            </Modal.Window>
        </Modal>
    )
}

export default CloudAccountReasonModal;